import React from 'react'
import PropTypes from 'prop-types'
import Row from '../Row'
import Spacer from '../Spacer'
import SplitFlapDigit from '../SplitFlapDigit'

const SIZES = {
    M: {
        spacer: 'XS',
    },
    S: {
        spacer: 'XXS',
    },
    XS: {
        spacer: 'XXS',
    },
}

const SplitFlapDisplay = ({
    number,
    length,
    color,
    size,
    ...rest
}) => {

    // It will ignore the decimals in the number prop
    const digits = Math.floor(number)
        .toString(10)
        .split('')
        .map((value, index) => ({ value: Number(value), index }))
    // ^^ the Number fn turn string into number again

    // Add zeros to the beginning of the array to reach the desired length
    const zeros = length - digits.length

    if (zeros > 0) {
        for (let i = 0; i < zeros; i += 1) {
            digits.unshift({ value: 0, index: digits.length + i })
        }
    }

    return (
        <Row flexWrap="wrap" {...rest}>
            {digits.map(({ value, index }, idx) => (
                <Row key={index}>
                    <SplitFlapDigit
                        value={value}
                        color={color}
                        size={size}
                    />
                    {idx !== digits.length - 1 && (
                        <Spacer row size={SIZES[size].spacer} />
                    )}
                </Row>
            ))}
        </Row>
    )
}

SplitFlapDisplay.propTypes = {
    number: PropTypes.number,
    length: PropTypes.number,
    color: PropTypes.oneOf(SplitFlapDigit.colors),
    size: PropTypes.oneOf(Object.keys(SIZES)),
}

SplitFlapDisplay.defaultProps = {
    number: 12345,
    length: 1,
    color: 'dark',
    size: 'M',
}

export default SplitFlapDisplay
